// extracted by css-extract-rspack-plugin
export default {"searchResultsContainer":"cJbH6","dropdownFooter":"IGygl","dropdownFooterSelected":"AC0Zs"};